package de.xtl.retroguide

import de.xtl.retroguide.protocol.MAX_ROTI
import de.xtl.retroguide.protocol.MIN_ROTI
import de.xtl.retroguide.protocol.VisibleAnswer
import de.xtl.retroguide.protocol.toRotiScore
import kotlin.math.roundToInt

internal data class RotiStats(val counts: List<Int>, val average: Double) {
    val votes: Int get() = counts.sum()
}

internal fun List<VisibleAnswer>.rotiStats(): RotiStats? {
    val scores = mapNotNull { it.content.toRotiScore() }
    if (scores.isEmpty()) return null
    return RotiStats(
        counts = (MIN_ROTI..MAX_ROTI).map { score -> scores.count { it == score } },
        average = scores.average(),
    )
}

internal fun Double.formatOneDecimal(): String {
    val tenths = (this * 10).roundToInt()
    return "${tenths / 10},${tenths % 10}"
}
